import { render } from "./HotMore.vue?vue&type=template&id=70a7a845&scoped=true"
import script from "./HotMore.vue?vue&type=script&lang=js"
export * from "./HotMore.vue?vue&type=script&lang=js"

import "./HotMore.vue?vue&type=style&index=0&id=70a7a845&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a7a845"]])

export default __exports__